export const initBankProgram = () => {
	const backLink = document.querySelector( 'section.cds2-bank-program-heading' );

	if ( !backLink )
	{
		return;
	}

	backLink.addEventListener( 'click', ( evt ) => {
		const hostRegExp = new RegExp( location.host, 'u' );
		
		if ( !hostRegExp.test( document.referrer ) )
		{
			return;
		}

		evt.preventDefault();
		history.back();
	} );
};
